import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';
import {CmsBannerCarouselComponent, CmsService, ContentSlotComponentData,} from '@spartacus/core';
import {CmsComponentData, ComponentWrapperDirective} from '@spartacus/storefront';
import {filter, map, Observable, tap} from 'rxjs';
import {NgbCarousel, NgbSlide} from '@ng-bootstrap/ng-bootstrap';
import {AsyncPipe, NgTemplateOutlet} from '@angular/common';

@Component({
    selector: 'app-efa-banner-carousel',
    templateUrl: './efa-banner-carousel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbCarousel, NgbSlide, NgTemplateOutlet, ComponentWrapperDirective, AsyncPipe]
})
export class EfaBannerCarouselComponent {
  @HostBinding('class') styleClasses: string | undefined;
  timeout: number;

  private readonly componentData$: Observable<CmsBannerCarouselComponent> =
    this.componentData.data$.pipe(
      filter((data: CmsBannerCarouselComponent) => data!==undefined),
      tap((data: CmsBannerCarouselComponent) => {
        this.styleClasses = data.styleClasses;
        // We should remove casting to any once the CmsBannerCarouselComponent is exported for augmentation.
        this.timeout =
          (data as any).timeout != null ? (data as any).timeout * 1000 : 0;
      })
    );

  private readonly items$: Observable<Observable<ContentSlotComponentData>[]> =
    this.componentData$.pipe(
      map(
        (data: CmsBannerCarouselComponent) =>
          data.banners?.trim().split(' ') ?? []
      ),
      map((codes: string[]) =>
        codes.map((code) => this.cmsService.getComponentData(code))
      )
    );

  constructor(
    private readonly componentData: CmsComponentData<CmsBannerCarouselComponent>,
    private readonly cmsService: CmsService
  ) {}

  getItems(): Observable<Observable<ContentSlotComponentData>[]> {
    return this.items$;
  }
}
